import { getEnvVariables } from './optionsService';

const parsedEnvValues = getEnvVariables();

export const TTD_DEMAND_PARTNER_ID = parsedEnvValues.ttdDemandPartnerId;
export const ENABLE_TTD_DATE = parsedEnvValues.minimumDateForTTDSync;
export const AMAZON_DEAL_SYNC_START_DATE = parsedEnvValues.amazonDealSyncStartDate;
export const DV360_DEMAND_PARTNER_ID = parsedEnvValues.dv360DemandPartnerId;
export const XANDR_DEMAND_PARTNER_ID = parsedEnvValues.xandrDemandPartnerId;
export const AMAZON_DEMAND_PARTNER_ID = parsedEnvValues.amazonDemandPartnerId;
export const AQUA_RTB_DEMAND_PARTNER_ID = parsedEnvValues.aquaDemandPartnerId;
export const BQ_JOB_MAX_REQUEST_COUNT = parsedEnvValues.bqJobMaxRequestCount;
export const BQ_JOB_REFETCH_INTERVAL = parsedEnvValues.bqJobRefetchInterval;
export const OPEN_AUDIENCE_ORG_ID = parsedEnvValues.openAudienceOrgId;
export const OPEN_AUDIENCE_ORG_UID = parsedEnvValues.openAudienceOrgUid;
export const OPEN_AUDIENCE_ORG_EXTERNAL_ID = parsedEnvValues.openAudienceOrgExternalId;
export const DEAL_SOURCE_DSP_SOURCED = 'OpenX - DSP Sourced';
export const OPEN_AUDIENCE_ORG_NAME = 'OpenAudience';
export const MINIMUM_ESTIMATED_REACH = parsedEnvValues.minimumEstimatedReach;
